import {html, css, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {connect, FeedAPIResponse, StreamClient, StreamFeed} from 'getstream'
import {msg, localized, str} from '@lit/localize';


@localized()
@customElement('dskrpt-footnote')
export class NotificationMenu extends LitElement {

    @property({type: Boolean}) show = false;

    static styles = css`
      :host {
        display: inline;
        position: relative;
      }
      
      div {
        position: absolute;
        top: 1.375rem;
        left: 0.125rem;
        background-color: white;
        width: 20rem;
        padding: .25rem 0.5rem;
        border-radius: 5px;
        font-size: 1rem;
        box-shadow: 0 3px 15px rgba(0, 0, 0, 0.25);
      }
    `;

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', (e) => {this.show = !this.show});
    }



    render() {
        return html`
            ${this.show ? html`<div><slot></slot></div>`: undefined}
        `
    }
}